<template>
  <sea-page
    :class="{ marginata: !isLoggedIn }"
    title="Privacy"
    header="Privacy"
  >
    <v-card style="padding: 5px" :flat="isLoggedIn">
      <div id="privacy" v-html="html"></div>
    </v-card>
  </sea-page>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.codCln = to.query.codCln;
      vm.codDist = to.query.codDist;
      vm.codFisc = to.query.codFisc;
      vm.numPrd = to.query.numPrd;
    });
  },
  mounted() {
    if (this.isLoggedIn) {
      this.privacy().then((res) => {
        if (res.success) {
          this.html = res.html;
        } else {
          this.html = "<h1>Si è verificato un errore</hi>";
        }
      });
    } else {
      this.privacyPage({
        cfazienda: this.codFisc,
        Codicecliente: this.codCln,
        Codicedistribuzione: this.codDist,
        NumeroProdotto: this.numPrd,
      }).then((res) => {
        if (res.success) {
          this.html = res.html;
        } else {
          this.html = "<h1>Si è verificato un errore</hi>";
        }
      });
    }
  },
  data() {
    return {
      html: null,
      codCln: null,
      codDist: null,
      codFisc: null,
      numPrd: null,
    };
  },
  methods: {
    ...mapActions({
      privacyPage: "account/privacyPage",
      privacy: "account/privacy",
    }),
  },
  computed: { ...mapGetters({ isLoggedIn: "account/authenticated" }) },
};
</script>

<style scoped>
.marginata {
  margin-top: 50px;
}
</style>
